<template>
    <RejectedPayments></RejectedPayments>
</template>
<script>
    import RejectedPayments from '@/components/EmployeeRejectedPayments.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            RejectedPayments
        }
    }
</script>